(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cfs-organizer-feature"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('cfs-organizer-feature')) {
  customElements.define('cfs-organizer-feature', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      this.templates = new Map(Array.from(this.querySelectorAll('[data-product-template]'), template => [template.dataset.productTemplate, template]));
      this.picker = this.querySelector('[data-product-picker]');
      const signal = this.controller.signal;
      this.addEventListener('click', event => {
        const productButton = event.target.closest('[data-product-button]');
        if (productButton && this.contains(productButton)) this.selectProduct(productButton.dataset.productButton);
        const viewButton = event.target.closest('[data-view-button]');
        if (viewButton && this.contains(viewButton)) {
          const panel = viewButton.closest('[data-product-panel]');
          panel.querySelectorAll('[data-view]').forEach(view => { view.hidden = view.dataset.view !== viewButton.dataset.viewButton; });
          panel.querySelectorAll('[data-view-button]').forEach(button => button.setAttribute('aria-pressed', String(button === viewButton)));
        }
      }, { signal });
      this.addEventListener('change', event => {
        if (event.target.matches('[data-product-picker]')) this.selectProduct(event.target.value);
        if (event.target.matches('[data-variant-picker]')) this.updateVariant(event.target);
      }, { signal });
      this.preparePanel(this.querySelector('[data-product-panel]'));
    }
    disconnectedCallback() { this.controller?.abort(); }
    preparePanel(panel) {
      if (!panel) return;
      const image = panel.querySelector('.cfs-org__image-link img');
      if (image) {
        image.dataset.originalSrc = image.getAttribute('src');
        image.dataset.originalSrcset = image.getAttribute('srcset') || '';
      }
      this.syncHero(panel);
    }
    syncHero(panel) {
      if (this.dataset.autoHero !== 'true') return;
      const image = panel.querySelector('.cfs-org__image-link img');
      const hero = this.querySelector('.cfs-org__hero-image');
      if (!image || !hero) return;
      hero.src = image.src;
      if (image.srcset) hero.srcset = image.srcset;
      else hero.removeAttribute('srcset');
      hero.alt = image.alt;
    }
    selectProduct(id) {
      const template = this.templates.get(String(id));
      const previous = this.querySelector('[data-product-panel]');
      if (!template || !previous || previous.dataset.productId === String(id)) return;
      const panel = template.content.firstElementChild.cloneNode(true);
      previous.replaceWith(panel);
      if (this.picker) this.picker.value = String(id);
      this.querySelectorAll('[data-product-button]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.productButton === String(id))));
      this.preparePanel(panel);
      const status = this.querySelector('[data-status]');
      if (status) status.textContent = `${this.dataset.selectedLabel} ${panel.dataset.productName}`;
      this.dispatchEvent(new CustomEvent('cfs:organizer:change', { bubbles: true, detail: { productId: String(id) } }));
    }
    updateVariant(select) {
      const option = select.selectedOptions[0];
      const panel = select.closest('[data-product-panel]');
      if (!option || !panel) return;
      const available = option.dataset.available === 'true';
      panel.querySelector('[data-price]').textContent = option.dataset.price;
      const compare = panel.querySelector('[data-compare]');
      compare.textContent = option.dataset.compare || '';
      compare.hidden = !option.dataset.compare;
      const status = panel.querySelector('[data-availability]');
      status.dataset.available = String(available);
      panel.querySelector('[data-availability-text]').textContent = available ? status.dataset.inStock : status.dataset.soldOut;
      const add = panel.querySelector('[data-add]');
      add.disabled = !available;
      panel.querySelector('[data-add-text]').textContent = available ? add.dataset.availableLabel : add.dataset.soldOutLabel;
      const image = panel.querySelector('.cfs-org__image-link img');
      if (image) {
        image.src = option.dataset.image || image.dataset.originalSrc;
        if (option.dataset.image) image.removeAttribute('srcset');
        else if (image.dataset.originalSrcset) image.srcset = image.dataset.originalSrcset;
        else image.removeAttribute('srcset');
      }
      this.syncHero(panel);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
